import type { ThirdPartyInvoiceLine } from './thirdPartyInvoiceLine';

export const THIRD_PARTY_NOTHING_TO_INVOICE = 'Nothing is left to invoice on this agreement.';
export const THIRD_PARTY_NO_SERVICES = 'No services are left to invoice.';
export const THIRD_PARTY_NO_ADD_ONS = 'No optional extras are left to invoice.';
export const THIRD_PARTY_INVOICING_NOT_FOUND = 'Agreement not found or failed to load.';
export const THIRD_PARTY_INVOICING_FAILED = 'Could not load what is left to invoice on this agreement.';

export const THIRD_PARTY_MODE_NOTE = 'One service or optional extra per invoice.';

export const THIRD_PARTY_DEALERS_LOADING = 'Loading invoicing dealers.';
export const THIRD_PARTY_DEALERS_FAILED = 'Could not load the dealers you can invoice for.';
export const THIRD_PARTY_NO_DEALERS = 'No dealers are available to invoice.';

export const THIRD_PARTY_INVOICE_REJECTED =
    'Could not be submitted. If this persists, please contact the agreement provider.';
export const THIRD_PARTY_INVOICE_UNCONFIRMED =
    'We could not confirm whether this invoice was submitted. Check with the agreement provider before trying again.';
export const thirdPartyInvoiceSubmitted = (invoiceNumber: string): string => `Invoice ${invoiceNumber} submitted.`;

export const THIRD_PARTY_SELECT_LINE = 'Select a service or optional extra to invoice.';
export const THIRD_PARTY_LINE_NOT_INVOICEABLE = 'This line cannot be invoiced.';
export const THIRD_PARTY_CHOOSE_DEALER = 'Choose the invoicing dealer.';

export function thirdPartyInvoiceDisabledReason(line: ThirdPartyInvoiceLine | null, dealerId: string | null): string | null {
    if (!line) return THIRD_PARTY_SELECT_LINE;
    if (line.contentId === null) return THIRD_PARTY_LINE_NOT_INVOICEABLE;
    if (!dealerId) return THIRD_PARTY_CHOOSE_DEALER;
    return null;
}
